import axios from '@/libs/api.request'

export const getTypeList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/type/page'
  })
}

export const addType = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/type'
  })
}

export const editType = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/type'
  })
}

export const delType = (id) => {
  return axios.request({
    method: 'delete',
    url: '/type/' + id
  })
}

export const getTypeInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/type/' + id
  })
}

export const changeTypeStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/type/status/' + id
  })
}
